import axios from "axios";

export function getContactsForCustomer(customerId) {
    const route = "/customers/{id}/contacts";
    return axios.get(route.replace("{id}", customerId));
}

export function getCustomerFromId(customerId) {
    const route = "/customers/{id}";
    return axios.get(route.replace("{id}", customerId));
}

export default function findCustomers(searchParams) {
    let queryString = "";

    if (searchParams) {
        queryString += "?";
        queryString += Object.keys(searchParams || {})
            .map(key => {
                const value = searchParams[key];
                return key + "=" + encodeURIComponent(value == null ? "" : String(value));
            })
            .join("&");
    }

    return axios.get("/customers/search" + queryString.toString());
}

export function setActiveCustomer(customerId) {
    const route = "/dashboard/{id}/setActiveCustomer";
    return axios.get(route.replace("{id}", customerId));
}

export function setActiveCustomerCategory(categoryId) {
    const route = "/dashboard/{id}/setActiveCustomerCategory";
    return axios.get(route.replace("{id}", categoryId));
}

export function setActiveUser(userId) {
    const route = "/dashboard/{id}/setActiveUser";
    return axios.get(route.replace("{id}", userId));
}

export function saveCustomerInfo(costEstimateId, customerInfo) {
    let route = "/cost-estimates/{costEstimateId}/saveCustomerInfo";
    route = route.replace('{costEstimateId}', costEstimateId);

    return axios.post(route, { customerInfo: customerInfo });
}

export function saveProductionInfo(costEstimateId, productionInfo) {
    let route = "/cost-estimates/{costEstimateId}/saveProductionInfo";
    route = route.replace('{costEstimateId}', costEstimateId);

    return axios.post(route, { productionInfo: productionInfo });
}
